import type { DehydratedState } from '@tanstack/query-core'
import { useMatches } from 'react-router'
import merge from 'deepmerge'

interface MatchData {
  dehydratedState?: DehydratedState
}

const useDehydratedState = (): DehydratedState | undefined => {
  const matches = useMatches() as { data?: MatchData }[] // Typing the matches

  const dehydratedState = matches
    .map(match => match.data?.dehydratedState)
    .filter(Boolean) // Filters out null/undefined values

  if (dehydratedState.length === 0) return undefined

  // Merge the dehydrated states
  return dehydratedState.reduce<DehydratedState>(
    (accumulator, currentValue) => {
      // Make sure currentValue is of type DehydratedState
      if (currentValue) {
        return merge<DehydratedState>(accumulator, currentValue)
      }
      return accumulator
    },
    {} as DehydratedState // Explicitly cast {} as DehydratedState
  )
}

export { useDehydratedState }
